const quadrantIds = [
  "freedom",
  "death",
  "creation",
  "improvement",
  "change",
  "life",
  "lies",
  "truth",
];

const baseQuadrantLayout = [
  { id: "source", top: "50%", left: "50%", children: quadrantIds },
  { id: "freedom", top: "87.5%", left: "50%" },
  { id: "lies", top: "75%", left: "25%" },
  { id: "death", top: "50%", left: "12.5%" },
  { id: "change", top: "25%", left: "25%" },
  { id: "truth", top: "12.5%", left: "50%" },
  { id: "life", top: "50%", left: "87.5%" },
  { id: "creation", top: "25%", left: "75%" },
  { id: "improvement", top: "75%", left: "75%" },
];

const defaultQuadrant = {
  backgroundColor: "#FFFFF0",
  glyphId: null,
  disabled: true,
  inUse: false,
  children: [],
};

const treeIds = [
  "source",
  "spirit",
  "mind",
  "body",
  "action",
  "assistance",
  "assurance",
  "name",
];

export const treeBlueprint = treeIds.map((treeId) => {
  return {
    id: treeId,
    name: treeId.charAt(0).toUpperCase() + treeId.slice(1),
    direction: null,
    terminusActive: false,
    quadrants: baseQuadrantLayout.map((layout) => ({
      ...defaultQuadrant,
      id: layout.id,
      displayName: layout.id.charAt(0).toUpperCase() + layout.id.slice(1),
      top: layout.top,
      left: layout.left,
      children: layout.children ?? [],
    })),
  };
});
